import React from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { PaymentTermsType } from '../stores';

export const formatTermType = (intl: IntlShape, termType: PaymentTermsType) => {
  switch (termType) {
    case PaymentTermsType.NET:
      return intl.formatMessage({
        defaultMessage: 'net',
      });
    case PaymentTermsType.NET_CASH:
      return intl.formatMessage({
        defaultMessage: 'net cash',
      });
    case PaymentTermsType.INVOICE_MONTH:
      return intl.formatMessage({
        defaultMessage: 'invoice month',
      });
    case PaymentTermsType.PREPAID:
      return intl.formatMessage({
        defaultMessage: 'prepaid',
      });
    case PaymentTermsType.CUSTOM:
      return intl.formatMessage({
        defaultMessage: 'custom',
      });
  }
};

export const formatTerms = (
  intl: IntlShape,
  {
    termsType,
    daysOfCredit,
  }: {
    termsType: PaymentTermsType;
    daysOfCredit?: number;
  }
) => {
  switch (termsType) {
    case PaymentTermsType.INVOICE_MONTH:
      if (daysOfCredit === undefined) {
        throw new TypeError(
          'Invalid arguments: daysOfCredit must not be undefined when termType is INVOICE_MONTH'
        );
      }
      return intl.formatMessage(
        {
          defaultMessage:
            'Inv. mo. {daysOfCredit, plural, one {# day} other {# days}}',
          description:
            'Invoice is due {daysOfCredit} after the end of the invoice month',
        },
        { daysOfCredit }
      );
    case PaymentTermsType.NET:
      if (daysOfCredit === undefined) {
        throw new TypeError(
          'Invalid arguments: daysOfCredit must not be undefined when termType is NET'
        );
      }
      return intl.formatMessage(
        {
          defaultMessage:
            'Net {daysOfCredit, plural, one {# day} other {# days}}',
          description: 'Invoice due {daysOfCredit} after invoice date',
        },
        { daysOfCredit }
      );
    case PaymentTermsType.NET_CASH:
      return intl.formatMessage({
        defaultMessage: 'Net cash',
        description: 'Net cash is paid upon receipt of invoice',
      });
    case PaymentTermsType.PREPAID:
      return intl.formatMessage({
        defaultMessage: 'Prepaid',
        description: 'Invoice is prepaid',
      });
    case PaymentTermsType.CUSTOM:
      return intl.formatMessage({
        defaultMessage: 'Custom payment terms',
        description: 'Custom',
      });
    default:
      return 'UNKOWN PAYMENT TERMS TYPE';
  }
};

export const FormattedTerms = (terms: {
  termsType: PaymentTermsType;
  daysOfCredit?: number;
}) => {
  const intl = useIntl();
  return <>{formatTerms(intl, terms)}</>;
};
